import React, { useState, useRef, useEffect, useContext } from "react";
import ContentLayout from '../../layout/ContentLayout'
import InvoiceDetail from './InvoiceDetail';
import { useParams, useNavigate } from 'react-router-dom';
import { get, post } from "../../services/apiService";
import { AppContext } from "../../context/context";
import { scrollUp } from "../../utils/Common";
import axios from "axios";


const InvoiceDetailPage = () => {
  const { id } = useParams(); // Get the id parameter from the URL
  const {
      state,
  } = useContext(AppContext);


  const {paperSize } = state;


  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const invoice = {
    logo: "https://example.com/logo.png",
    name: "Acme Corporation",
    number: "INV-12345",
    date: "2023-10-04",
    created_at: "2023-10-04",
    invoice_id: "INV-12345",
    customer_name: "John Doe",
    customer_phone: "123213123",
    sales_details: [
      {
        id: 1,
        name: "Widget A",
        qty: 2,
        price: 10,
        total: 20,
        product_info: {
          name: "Widget A",
          price: 10
        }
      },
      {
        id: 2,
        name: "Widget B",
        qty: 1,
        price: 50,
        total: 50,
        product_info: {
          name: "Widget B",
          price: 50
        }
      },
      {
        id: 3,
        name: "Widget C",
        qty: 1,
        price: 100,
        total: 100,
        product_info: {
          name: "Widget C",
          price: 100
        }
      }
    ],
    sub_total: 170,
    tax: 25.5,
    paid_amount: 195.5,
    vat: 15
  };
  const [invoiceData, setInvoiceData] = useState(invoice);
  const [invoiceDataImeis, setInvoiceDataImeis] = useState([]);
  const [exChangeImeis, setExChangeImeis] = useState([]);
  const [loading, setLoading] = useState(false);
    const loadingCallback = loading => {
      setLoading(loading);
    };

    console.log(exChangeImeis)


  useEffect(() => {
      // Fetch invoice data based on the ID and populate
      console.log(invoiceData);
      fetchInvoiceData(id);
      fetchDescriptions();
  }, [id]);

  const fetchInvoiceData = (invoiceId) => {
    // Make an API request to fetch product data by ID
    // Once data is retrieved, update the form fields with the data
    loadingCallback(true)
    post("invoice-details", { 'invoice_id': invoiceId }, token)
      .then((response) => {
        loadingCallback(false)
        const invoiceData = response.data; // Replace with your API response data
        console.log("============");
        console.log(invoiceData);
        setInvoiceData(invoiceData);

        const invoiceDataImei = response.data.data_imeis;
        setInvoiceDataImeis(invoiceDataImei)

        console.log(response?.data.exchange_imeis)
        // const invoiceExchangeImeis = response.exchange_imeis;
        setExChangeImeis(response?.data.exchange_imeis)

      })
      .catch((error) => {
        console.log(error);
        // if (error?.response?.status === 401) {
        //   localStorage.setItem('token', '');
        //   localStorage.setItem('token', '');
        //   // Clear session and local storage
        //   localStorage.setItem('isPinVerify', false);
        //   navigate('/login');
        // }
      });
  };

  const [inputs, setInputs] = useState([{ id: null, description: "" }]);

  const fetchDescriptions = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}terms-conditions-list`, {
        headers: {
          authorization: `Bearer ${token}`,
        },
      });
      if (response.data.success) {
        const descriptions = response.data.data.map(item => ({ id: item.id, description: item.description }));
        //setInputs(descriptions);
        setInputs(descriptions.length > 0 ? descriptions : [{ id: null, description: "" }]);
        console.log("list", descriptions);
      }
    } catch (error) {
      console.error("Error fetching descriptions:", error);
    }
  };

  //scroll up
  useEffect(()=>{
    scrollUp()
  },[])
  return (
    <>
      <ContentLayout>
        <div className="main-content recentTableContent">
          <div className="RecentOrdersTable-container flex flex-col w-full">
            {console.log("invoiceData ", invoiceData )}
            { invoiceData && invoiceData.invoice_id && (
              <InvoiceDetail paperSize={paperSize} invoice={invoiceData}  invoiceImeis={invoiceDataImeis} inputs={inputs} exChangeImeis={exChangeImeis}/>
            )}

          </div>
          {loading && (
              <div className="custom-loader-logo">
                <img
                  className=""
                  src={`${process.env.REACT_APP_ROOT_URL + "/smallLogo.png"}`}
                  alt="logo"
                />
              </div>
            )
            }
        </div>
      </ContentLayout>
    </>
  );
};


export default InvoiceDetailPage